import { PDFFeatureAnalysis } from "../../features/pdf";

export const PDFBusinessMetrics = PDFFeatureAnalysis;
